import { ResponseBody } from './../../overrides/model/ResponseBody.js';
import { Expose } from 'class-transformer';
import { Transform } from 'class-transformer';
import { Type } from 'class-transformer';
import { LandingPageExtraFeatureFlags } from './../../overrides/model/LandingPageExtraFeatureFlags.js';
import { default as camelize } from 'camelize-ts';
import { LandingPageBlockType } from './../../overrides/model/LandingPageBlockType.js';
import type { Constructor } from '@whispli/types';

export class __LandingPageExtra extends ResponseBody {
  /**
   * @deprecated For backwards-compatibility only. Use organizationName
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private organization_name!: string;

  @Expose({groups: ['client']})
  public get organizationName() {
    return this.organization_name
  }

  public set organizationName(value) {
    this.organization_name = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use organizationFooter
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private organization_footer!: string;

  @Expose({groups: ['client']})
  public get organizationFooter() {
    return this.organization_footer
  }

  public set organizationFooter(value) {
    this.organization_footer = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use organizationTitlePrepend
   */
  @Expose({groups:["server"]})
  @Type(() => Object)
  private organization_title_prepend!: string | null;

  @Expose({groups: ['client']})
  public get organizationTitlePrepend() {
    return this.organization_title_prepend
  }

  public set organizationTitlePrepend(value) {
    this.organization_title_prepend = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use organizationLogo
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private organization_logo!: string;

  @Expose({groups: ['client']})
  public get organizationLogo() {
    return this.organization_logo
  }

  public set organizationLogo(value) {
    this.organization_logo = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use organizationStatus
   */
  @Expose({groups:["server"]})
  @Type(() => String)
  private organization_status?: string;

  @Expose({groups: ['client']})
  public get organizationStatus() {
    return this.organization_status
  }

  public set organizationStatus(value) {
    this.organization_status = value
  }

  /**
   * @todo property is of unknown type
   * @deprecated For backwards-compatibility only. Use featureFlags
   */
  @Type(() => LandingPageExtraFeatureFlags)
  @Type(() => Object)
  @Transform(({ obj }) => typeof obj.feature_flags === 'object' ? camelize(obj.feature_flags) : null)
  @Expose({groups:["server"]})
  private feature_flags!: LandingPageExtraFeatureFlags;

  @Expose({groups: ['client']})
  public get featureFlags() {
    return this.feature_flags
  }

  public set featureFlags(value) {
    this.feature_flags = value
  }

  /**
   * @deprecated For backwards-compatibility only. Use landingPageBlockTypes
   */
  @Type(() => LandingPageBlockType)
  @Expose({groups:["server"]})
  private landing_page_block_types!: (LandingPageBlockType)[];

  @Expose({groups: ['client']})
  public get landingPageBlockTypes() {
    return this.landing_page_block_types
  }

  public set landingPageBlockTypes(value) {
    this.landing_page_block_types = value
  }
}

interface OptionalAlias {
  organizationStatus?: string | undefined;
}
export type LandingPageExtra = Omit<__LandingPageExtra, '__typename' | '__key' | '__locale' | '__omit' | 'toJSON' | 'isEqual' | 'organization_name' | 'organization_footer' | 'organization_title_prepend' | 'organization_logo' | 'organization_status' | 'feature_flags' | 'landing_page_block_types' | 'organizationStatus'> & OptionalAlias
export const LandingPageExtra = __LandingPageExtra as any as Constructor<LandingPageExtra>
